import { reccImplementationDataPart1 } from './reccImplementationData_part1';
import { reccImplementationDataPart2 } from './reccImplementationData_part2';

// Combined ARC implementation guide data used across assessment results
export const reccImplementationData = {
  ...reccImplementationDataPart1,
  ...reccImplementationDataPart2,
};


